exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#sex-age .form-label{float:left;color:#666;font-size:small;margin-right:10px;float:none;margin-bottom:-10px}#sex-age select{width:auto!important}#sex-age .text{font-size:small;margin-bottom:1em}#sex-age .flex{display:flex}#sex-age .flex>div:first-child{margin-right:20px}#sex-age .mdl-radio{margin-top:5px;padding-right:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-0a6d9ca4!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/SexAge.vue
// module id = 176
// module chunks = 0